export default "__VITE_ASSET__453f4292__"